import { render, staticRenderFns } from "./Top10Cari.vue?vue&type=template&id=0fba447d&scoped=true"
import script from "./Top10Cari.vue?vue&type=script&lang=js"
export * from "./Top10Cari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba447d",
  null
  
)

export default component.exports